// extracted by mini-css-extract-plugin
module.exports = {"formDate":"FormDate_formDate__P4zTH","rotation":"FormDate_rotation__xtZg_"};